import { render, staticRenderFns } from "./comprehensiveInspection.vue?vue&type=template&id=4bf771fd&scoped=true&"
import script from "./comprehensiveInspection.vue?vue&type=script&lang=js&"
export * from "./comprehensiveInspection.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveInspection.vue?vue&type=style&index=0&id=4bf771fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf771fd",
  null
  
)

component.options.__file = "comprehensiveInspection.vue"
export default component.exports